import { CheckBox, CheckBoxOutlineBlank, Search } from "@mui/icons-material";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  TextField,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { css, StyleSheet } from "aphrodite";
import Select from "react-select";

export const FilterDespesa = (props) => {
  const textFieldStyles = {
    marginTop: "0.5rem",
    "& .MuiInputBase-root": {
      height: "30px",
      fontSize: 12,
      backgroundColor: "inherit",
      display: "flex",
      alignItems: "center",
    },
    "& .MuiInputBase-input": {
      height: "30px",
      boxSizing: "border-box",
      cursor: "text",
      fontSize: "12px",
      textAlign: "left",
      '&[type="date"]': {
        fontSize: "14px",
      },
      "&.Mui-readOnly": {
        fontSize: "12px",
        "-webkit-text-fill-color": "inherit",
      },
      "&::placeholder": {
        fontSize: "12px",
        opacity: 1,
        textAlign: "left",
      },
    },
    "& .MuiInputLabel-root": {
      fontSize: 10,
      transform: "translate(10px, 6px) scale(1)",
      "& .MuiFormLabel-asterisk": {
        color: "red",
        fontWeight: "bold",
      },
    },
    "& .MuiInputLabel-shrink": {
      transform: "translate(10px, -8px) scale(0.75)",
    },
  };

  const theme = useTheme();
  const isLg = useMediaQuery(theme.breakpoints.up("lg"));
  const isMd = useMediaQuery(theme.breakpoints.up("md"));
  const isSm = useMediaQuery(theme.breakpoints.up("sm"));

  const getLimitTags = () => {
    if (isLg) return 5;
    if (isMd) return 4;
    if (isSm) return 3;
    return 1;
  };

  return (
    <>
      <Box>
        {props.isSearch ? (
          <>
            <Paper sx={{ borderRadius: 1, overflow: "hidden" }} elevation={1}>
              <Box
                sx={{
                  px: 2,
                  py: 0.5,
                  bgcolor: "#669966",
                  color: "white",
                  fontWeight: 600,
                  fontSize: 14,
                }}
              >
                Consulta de Despesa
              </Box>

              <Box sx={{ px: 1, paddingTop: 0.5, paddingBottom: 1.5 }}>
                <Grid container spacing={0.75} alignItems="flex-end">
                  <Grid size={{ xs: 12, sm: 10 }}>
                    <TextField
                      sx={textFieldStyles}
                      label="Busca de Despesa"
                      size="small"
                      fullWidth
                      color="success"
                      value={props.searchValue}
                      onChange={(e) => props.setSearchValue(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") props.searchDespesa();
                      }}
                    />
                  </Grid>

                  <Grid
                    size={{ xs: 12, sm: 2 }}
                    sx={{
                      display: "flex",
                      justifyContent: { xs: "flex-start", sm: "flex-end" },
                    }}
                  >
                    <IconButton
                      onClick={() => props.searchDespesa()}
                      className={css(styles.btn)}
                      title="Buscar"
                    >
                      <Search fontSize="small" />
                    </IconButton>
                  </Grid>
                </Grid>
              </Box>
            </Paper>
          </>
        ) : (
          <>
            <Paper sx={{ borderRadius: 1, overflow: "hidden" }} elevation={1}>
              <Box
                sx={{
                  px: 2,
                  py: 0.5,
                  bgcolor: "#669966",
                  color: "white",
                  fontWeight: 600,
                  fontSize: 14,
                }}
              >
                Informações Principais
              </Box>

              <Box sx={{ px: 1, paddingTop: 0.5, paddingBottom: 1.5 }}>
                <Grid container spacing={0.75} alignItems="flex-end">
                  <Grid size={{ xs: 12 }}>
                    <TextField
                      sx={textFieldStyles}
                      label="Descrição"
                      size="small"
                      fullWidth
                      required
                      color="success"
                      error={!!props.errors?.descricao}
                      inputRef={props.descricaoRef}
                      value={props.descricao}
                      onChange={(e) => {
                        props.setDescricao(e.target.value);
                        if (props.errors?.descricao) {
                          props.setErrors((prev) => ({
                            ...prev,
                            descricao: false,
                          }));
                        }
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") props.cadDespesa();
                      }}
                    />
                  </Grid>
                </Grid>

                <Grid size={{ xs: 12, sm: 9, md: 5, lg: 4 }}>
                  <Autocomplete
                    multiple
                    size="small"
                    limitTags={getLimitTags()}
                    options={(props.centroCustoList || []).filter(
                      (item) =>
                        !item.inativo ||
                        (props.centrosSelecionados || []).some(
                          (sel) => sel.id === item.id,
                        ),
                    )}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    getOptionLabel={(option) => option.name || ""}
                    getOptionDisabled={(option) => option.inativo}
                    value={props.centrosSelecionados || []}
                    onChange={(event, newValue) => {
                      props.setCentrosSelecionados(newValue);
                      if (props.errors?.centrosSelecionados) {
                        props.setErrors((prev) => ({
                          ...prev,
                          centrosSelecionados: false,
                        }));
                      }
                    }}
                    disableCloseOnSelect
                    renderOption={(liProps, option, { selected }) => (
                      <li
                        {...liProps}
                        key={option.id}
                        style={{
                          fontSize: 11,
                          padding: "4px",
                          color: option.inativo ? "#999" : "inherit",
                        }}
                      >
                        <Checkbox
                          icon={<CheckBoxOutlineBlank fontSize="small" />}
                          checkedIcon={<CheckBox fontSize="small" />}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option.name} {option.inativo ? "(Cancelado)" : ""}
                      </li>
                    )}
                    sx={{
                      ...textFieldStyles,
                      "& .MuiInputBase-root": {
                        display: "flex",
                        flexWrap: "wrap",
                        height: "auto !important",
                        minHeight: "30px",
                        padding: "2px 4px !important",
                        fontSize: 12,
                      },
                      "& .MuiAutocomplete-inputRoot": {
                        cursor: "text",
                      },
                      "& .MuiChip-root": {
                        height: "22px",
                        fontSize: "10px",
                        margin: "2px",
                        backgroundColor: (theme) => "rgba(0,0,0,0.08)",
                      },
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Centros de Custo"
                        color="success"
                        required
                        error={!!props.errors?.centrosSelecionados}
                        inputRef={props.centroRef}
                      />
                    )}
                  />
                </Grid>
              </Box>
            </Paper>
            <Grid
              size={{ xs: 12 }}
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                flexWrap: "wrap",
                gap: 0.5,
                mt: 1,
              }}
            >
              <Button
                variant="outlined"
                color="inherit"
                sx={{ minWidth: 120, fontSize: 12 }}
                onClick={() => props.handleBack()}
              >
                Cancelar
              </Button>
              <Button
                variant="contained"
                color="success"
                onClick={() => props.cadDespesa()}
                sx={{ minWidth: 120, fontSize: 12, bgcolor: "#669966" }}
              >
                Salvar
              </Button>
            </Grid>
          </>
        )}
      </Box>
    </>
  );
};

const styles = StyleSheet.create({
  input: {
    fontFamily: "Poppins !important",
    fontSize: 12,
    fontWeight: 400,
    color: "#808080",
    transitionDuration: "0.2s",
  },
  btn: {
    backgroundColor: "#669966",
    color: "#fff",
    fontFamily: "Poppins",
    fontSize: 12,
    fontWeight: 600,
    borderStyle: "solid",
    borderWidth: 0.5,
    borderColor: "#669966",
    borderRadius: 6,
    display: "flex !important",
    justifyContent: "center !important",
    alignContent: "center !important",
    padding: 0,
    width: "100%",
    height: 30,
    transitionDuration: "0.2s",
    ":hover": {
      color: "#669966",
      backgroundColor: "transparent !important",
      borderColor: "#669966 !important",
    },
    ":active": {
      color: "#669966",
      backgroundColor: "transparent !important",
      borderColor: "#669966 !important",
      opacity: 0.6,
    },
  },
  btnDisabled: {
    backgroundColor: "#B3B3B3",
    color: "#fff",
    fontFamily: "Poppins",
    fontSize: 12,
    fontWeight: 600,
    borderStyle: "solid",
    borderWidth: 0.5,
    borderColor: "#B3B3B3",
    borderRadius: 6,

    display: "flex !important",
    justifyContent: "center !important",
    alignContent: "center !important",
    padding: 0,
    width: "100%",
    height: 34,
  },
  erro: {
    // fontFamily: "Poppins",
    fontSize: 14,
    color: "red",
    textAlign: "center",
    fontWeight: 600,
    marginTop: "1rem",
    marginBottom: "-0.5rem",
  },
});
